import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const MobileViewerHeader = ({ 
  modelName, 
  searchTerm, 
  onSearchChange, 
  onReset,
  onOpenPartsDrawer,
  onOpenSpecs,
  selectedComponent,
  componentVisibility = {},
  onToggleVisibility,
  onIsolate
}) => {
  return (
    <div className="fixed top-[104px] left-0 right-0 z-[39] bg-card/95 backdrop-blur-soft border-b border-border shadow-md">
      {/* Model Name */}
      <div 
        className="px-4 py-2 border-b border-border/50 flex justify-between items-center active:bg-muted/50 cursor-pointer"
        onClick={onOpenSpecs}
      >
        <h3 className="text-sm font-bold text-foreground truncate">{modelName}</h3>
        <Icon name="Info" size={16} className="text-muted-foreground shrink-0 ml-2" />
      </div>
      
      {/* Search, Actions, and Reset */}
      <div className="px-4 py-2 flex items-center gap-2">
        <div 
          onClick={onOpenPartsDrawer}
          className="flex-1 h-9 bg-card border border-border rounded-lg flex items-center justify-between px-3 text-muted-foreground text-sm cursor-pointer select-none active:bg-muted/40 transition-colors"
        >
          <div className="flex items-center gap-2 overflow-hidden">
            <Icon name="Search" size={16} className="text-muted-foreground shrink-0" />
            <span className="truncate">{searchTerm || 'Search parts...'}</span>
          </div>
          {searchTerm && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onSearchChange('');
              }}
              className="p-1 hover:text-foreground text-muted-foreground shrink-0"
            >
              <Icon name="X" size={14} />
            </button>
          )}
        </div>

        {/* Symmetrical Mobile Quick Part Actions */}
        <Button 
          variant="outline" 
          size="sm" 
          disabled={!selectedComponent}
          onClick={() => selectedComponent && onToggleVisibility(selectedComponent.id)}
          className={`h-9 px-2.5 shrink-0 ${!selectedComponent ? 'opacity-40' : ''}`}
          title="Show/Hide Highlighted Part"
        >
          <Icon 
            name={selectedComponent && componentVisibility[selectedComponent.id] === false ? "EyeOff" : "Eye"} 
            size={16} 
            className={selectedComponent && componentVisibility[selectedComponent.id] === false ? "text-red-500" : "text-primary"}
          />
        </Button>

        <Button 
          variant="outline" 
          size="sm" 
          disabled={!selectedComponent}
          onClick={() => selectedComponent && onIsolate(selectedComponent.id)}
          className={`h-9 px-2.5 shrink-0 ${!selectedComponent ? 'opacity-40' : ''}`}
          title="Isolate Highlighted Part"
        >
          <Icon name="Focus" size={16} className={selectedComponent ? "text-primary" : ""} />
        </Button>

        <Button 
          variant="outline" 
          size="sm" 
          onClick={onReset}
          className="h-9 whitespace-nowrap px-3 shrink-0"
        >
          <Icon name="RefreshCcw" size={16} className="mr-1" />
          Reset
        </Button>
      </div>
    </div>
  );
};

export default MobileViewerHeader;
